import React from "react";
import styled from "styled-components";
import {Link} from "react-router-dom";
import {useContractRead} from "wagmi";
import { WARRIOR_NFT, synthAbi } from '@/utils/abi'
import genieImage from '@/assets/imgs/nfts/genie.png'
import knightImage from '@/assets/imgs/nfts/knight.png'


function SynthResult({ tokenId, onClose }) {


  const {data} = useContractRead({
    address: WARRIOR_NFT,
    abi: synthAbi,
    functionName: 'tokenTypes',
    args: [tokenId],
  })

  const src = data === 7 ? genieImage : data === 8 ? knightImage : ''

  return (
      <Wrapper>
        <div className="modal-head">
          <div className="modal-title">Mint Successful！</div>
        </div>
        <div className="content">
          { src && <img src={src}/>}
        </div>
        <div className="btns-group">
          <Link to="/warrior">
            <button className="btn-mint normal">Check My Squad</button>
          </Link>
          <button className="btn-mint" onClick={onClose}>Mint More</button>
        </div>
      </Wrapper>
  )
}
export default SynthResult;

const Wrapper = styled.div`
  position: relative;

  .content {
    padding: 30px 0 50px;
    height: 380px;
    box-sizing: border-box;
    
    img {
      width: 300px;
      height: 300px;
      display: block;
      border-radius: 20px;
      margin: 0 auto;
    }
  }

  .modal-head {
    display: flex;
    justify-content: center;
    flex-direction: column;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    padding-bottom: 20px;
  }

  .modal-title {
    font-size: 30px;
    line-height: 42px;
    font-weight: 600;
    color: #32DE86;
  }
  
  .btns-group {
    display: flex;
    gap: 40px;
    justify-content: center;
  }

  .btn-mint {
    height: 44px;
    padding: 0 60px;
    min-width: 380px;
    color: #fff;
    border: none;
    background: #32DE86;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    
    &.normal {
      background-color: #fff;
      color: #32DE86;
    }
  }
`;


